import React from "react";
import cx from "clsx";
import styles from "./scss/SectionTitle.module.scss";

const SectionTitle = ({ children, className }) => {
  return (
    <div className={styles.sectionTitleContainer}>
      <h1 className={cx(styles.sectionTitle, className)}>{children}</h1>
    </div>
  );
};

export default SectionTitle;
